import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import Services from "../pages/services/page";
import Landscaping from "../pages/services/landscaping/page";
import InteriorWorks from "../pages/services/interior-works/page";
import UpvcWindows from "../pages/services/upvc-windows/page";
import CivilWaterproofing from "../pages/services/civil-waterproofing/page";
import DeepCleaning from "../pages/services/deep-cleaning/page";
import FlooringWallPaneling from "../pages/services/flooring-wall-paneling/page";
import SwimmingPoolFountain from "../pages/services/swimming-pool-fountain/page";
import Projects from "../pages/projects/page";
import Testimonials from "../pages/testimonials/page";
import Blog from "../pages/blog/page";
import Contact from "../pages/contact/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/about", element: <About /> },
  { path: "/services", element: <Services /> },
  { path: "/services/landscaping", element: <Landscaping /> },
  { path: "/services/interior-works", element: <InteriorWorks /> },
  { path: "/services/upvc-windows", element: <UpvcWindows /> },
  { path: "/services/civil-waterproofing", element: <CivilWaterproofing /> },
  { path: "/services/deep-cleaning", element: <DeepCleaning /> },
  { path: "/services/flooring-wall-paneling", element: <FlooringWallPaneling /> },
  { path: "/services/swimming-pool-fountain", element: <SwimmingPoolFountain /> },
  { path: "/projects", element: <Projects /> },
  { path: "/testimonials", element: <Testimonials /> },
  { path: "/blog", element: <Blog /> },
  { path: "/contact", element: <Contact /> },
  { path: "*", element: <NotFound /> },
];

export default routes;